import type { ReactElement } from 'react';
import { Button } from '@vwpfs/mary-air-lib/components/air/05-atoms/Button';
import { ThemePalette } from '@vwpfs/mary-air-lib/theme/_Types';
import { useAppLogout } from '../auth/useAppLogout';

export function LogoutButton(): ReactElement {
  const logout = useAppLogout();

  return (
    <Button
      buttonType="button"
      theme={{ palette: ThemePalette.CONTRAST_TERTIARY }}
      link={{
        onClick: logout
      }}
    >
      Logout
    </Button>
  );
}
